import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useSettings } from "hooks";
import type { MerchantSettings } from "features/merchants/types";
import { ClipboardTextField } from "ui/molecules/Input";

const SetupPluginContent = () => {
    const { getSettings } = useSettings<MerchantSettings>();

    const { apiGuid, apiId } = getSettings();

    return (
        <Box
            sx={{
                display: 'grid',
                gap: 2
            }}
        >
            <Typography>
                Copy provided <strong>API key</strong> into the Macropay’s plugin settings in your WP Admin panel.
            </Typography>
            <ClipboardTextField
                defaultValue={apiId}
                label='API ID'
                size='small'
            />
            <ClipboardTextField
                defaultValue={apiGuid}
                label='API GUID'
                size='small'
            />
        </Box>
    );
};

export default SetupPluginContent;
